import React from 'react';
import { getCollectConfig } from '@chat/utils';
import Collect from './Collect';

function MsgCollect({ message, msg_type }): JSX.Element {
    const { collect_type, err_fields } = message;
    const collectConfig = getCollectConfig(collect_type);
    const msgClassName = classnames(['im-message-collect', `im-message-${msg_type}`]);
    const formWrapClassName = classnames(['im-message-form-wrap']);
    const errorTxt = () =>
        collectConfig?.fields
            ?.filter((item) => _.includes(err_fields, item.key))
            .map((item) => `“${item.label}”`)
            .join('，');
    const greeting =
        collectConfig?.greeting || '为了更好地解决您遇到的问题，请填写并提交相关信息吧~';

    return (
        <div className={msgClassName}>
            <div className="txt">
                <span>
                    {_.isEmpty(err_fields)
                        ? greeting
                        : `以下字段有误：${errorTxt()}，请填写后重新提交哦~`}
                </span>
            </div>
            <div className={formWrapClassName}>
                <Collect message={message} msg_type={msg_type} />
            </div>
        </div>
    );
}

export default MsgCollect;
